<template>
  <el-row class="auth-container flex-full-xs flex-column-items-xs mobile-position-fixed">
    <el-col>
      <el-row
        type="flex"
        justify="center"
        class="links"
      >
        <el-col class="box">
          <router-link
            :to="{ name: 'Login' }"
            class="login-link"
          >
            {{ $t('sign-up.login-text') }}
          </router-link>
          <router-link
            :to="{ name: 'SignUp' }"
            class="signup-link"
          >
            {{ $t('sign-up.title-text') }}
          </router-link>
          <div class="clearfix" />
          <el-row
            type="flex"
            justify="center"
            class="auth-form"
          >
            <el-form
              v-loading.fullscreen.lock="loading"
              class="login-signup-form"
              :label-position="labelPosition"
              :model="form"
              :element-loading-background="'rgba(0,0,0,0.7)'"
              @submit.native.prevent="onSubmit"
            >
              <el-col>
                <el-form-item :error="error('name')">
                  <el-input
                    v-model="form.name"
                    :placeholder="$t('sign-up.name.placeholder')"
                    @change="change('name')"
                  >
                    <i
                      slot="prefix"
                      class="icon-man-user"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :error="error('email')">
                  <el-input
                    v-model="form.email"
                    :placeholder="$t('sign-up.email.placeholder')"
                    @change="change('email')"
                  >
                    <i
                      slot="prefix"
                      class="icon-envelope"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :error="error('password')">
                  <el-input
                    v-model="form.password"
                    :placeholder="$t('sign-up.password.placeholder')"
                    :type="showPassword ? 'text': 'password'"
                    @change="change('password')"
                  >
                    <i
                      slot="prefix"
                      class="icon-lock"
                    />
                    <i
                      slot="suffix"
                      :class="showPassword ? 'icon-blind' : 'icon-eye'"
                      @click="showPassword = !showPassword"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :error="error('password_confirm')">
                  <el-input
                    v-model="form.password_confirm"
                    :placeholder="$t('sign-up.re-password.placeholder')"
                    :type="showPasswordConfirm ? 'text': 'password'"
                    @change="change('password_confirm')"
                  >
                    <i
                      slot="prefix"
                      class="icon-lock"
                    />
                    <i
                      slot="suffix"
                      :class="showPasswordConfirm ? 'icon-blind': 'icon-eye'"
                      @click="showPasswordConfirm = !showPasswordConfirm"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col class="hidden-xs-only">
                <p class="click">
                  {{ $t('sign-up.terms-privacy') }}
                  <router-link :to="{ name: 'Trust and Safety' }">
                    {{ $t('sign-up.terms') }}
                  </router-link>
                  {{ isSpecialLocale ? 'و' : '&' }}
                  <router-link :to="{ name: 'Privacy policy' }">
                    {{ $t('sign-up.privacy') }}
                  </router-link>
                </p>
              </el-col>
              <el-col>
                <el-form-item>
                  <el-button
                    class="submit-button"
                    native-type="submit"
                  >
                    {{ $t('sign-up.title-text') }}
                  </el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="text-center hidden-sm-and-up">
      <p class="click">
        {{ $t('sign-up.terms-privacy') }}
        <router-link :to="{ name: 'Trust and Safety' }">
          {{ $t('sign-up.terms') }}
        </router-link>
        {{ isSpecialLocale ? 'و' : '&' }}
        <router-link :to="{ name: 'Privacy policy' }">
          {{ $t('sign-up.privacy') }}
        </router-link>
      </p>
    </el-col>
    <el-col class="flex-full-xs flex-column-items-xs p-b-xs-10">
      <el-row class="login text-center flex-full-xs flex-column-items-xs">
        <span>{{ $t('sign-up.already-user') }}
          <router-link :to="{ name: 'Login' }">{{ $t('sign-up.login-text') }}<i class="icon-arrow-r" /></router-link>
        </span>
      </el-row>
    </el-col>
    <el-col class="text-center flex-full-xs p-b-xs-150">
      <router-link
        :to="{ name: 'Home' }"
        tag="button"
        class="skip-button"
      >
        {{ $t('sign-up.skip-text') }}
      </router-link>
    </el-col>
  </el-row>
</template>

<script>
/* eslint-disable no-unused-vars */

import { mapState } from 'vuex';
import mutations from '../store/auth/auth.mutationlist';
import Form from '../components/Core/ResourcePage';

export default {
  extends: Form,
  data() {
    return {
      labelPosition: 'left',
      showPassword: false,
      showPasswordConfirm: false,
      form: {
        name: '',
        email: '',
        password: '',
        password_confirm: '',
      },
      errors: {},
      loading: false,
    };
  },
  computed: {
    ...mapState({
      locale: state => state.locale,
    }),
    isSpecialLocale() {
      return ['fa', 'ps'].indexOf(this.locale) !== -1;
    },
  },
  methods: {
    error(index) {
      return this.errors[index] === undefined ? '' : this.errors[index][0];
    },
    onSubmit() {
      this.loading = true;
      this
        .$http
        .post('/auth/register', { ...this.form })
        .then((response) => {
          this.loading = false;
          this.$store.commit(mutations.REGISTER, response.data);
          this.$router.push({ name: 'Home' });
        })
        .catch(({ response }) => {
          this.onFormError(response);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/SignUp.vue